import React from 'react';
import {
 Table, FormGroup, Input, Label,
} from 'reactstrap';
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons';
import { httpClient } from '@s20/services/httpClient';
import { BaseFormViewModel } from '../common/ViewModel';
import { toasty } from '../common/forms/FormElements';
import CommonContext, { ApiRoutes } from '../Common';
import SlideForm from '../common/forms/SlideForm';
import { handleFormSaveError } from '../common/forms/ValidationError';

export class ManageTenantHolidays extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();

        this.state = {
            tenantId: null,
            holidays: [],
            ...new BaseFormViewModel(),
        };

        this.handleSaveError = this.handleSaveError.bind(this);
    }

    handleSaveError = (err) => handleFormSaveError(this, err);

    onClose = () => {
        this.props.toggleShow(false);
        this.context.setFormOpened(false);
        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    onSubmit = async () => {
        const { tenantId, holidays } = this.state;
        this.setState({ errors: {}, saving: true });

        const excludedIds = holidays.filter((h) => !h.isPaid).map((h) => h.id);
        const response = await httpClient
            .put(ApiRoutes.holiday.tenantHolidays(tenantId), excludedIds)
            .catch(this.handleSaveError);

        if (response) {
            this.onClose();
            toasty.success('Saved', 'Holiday pay rules updated.');
        }

        this.setState({ saving: false });
    };

    open = async (tenantId) => {
        this.setState({ loading: true, tenantId });
        this.props.toggleShow(true);
        this.context.setFormOpened(true);

        const holidays = await httpClient.js(ApiRoutes.holiday.tenantHolidays(tenantId));
        this.setState({ holidays, loading: false });
    };

    toggleHoliday = (id) => {
        this.setState((prev) => ({
            holidays: prev.holidays.map((h) =>
                h.id === id ? { ...h, isPaid: !h.isPaid } : h,
            ),
        }));
    };

    render() {
        const { holidays } = this.state;

        return (
            <SlideForm
                loading={this.state.loading}
                show={this.props.show}
                id="tenantHolidaysForm"
                formIcon={faCalendarCheck}
                formTitle="Holiday Pay Rules"
                ref={this.formRef}
                setIsValidated={(value) => this.setState({ formValidated: value })}
                isValidated={this.state.formValidated}
                onSubmit={this.onSubmit}
                onClose={this.onClose}
                errors={this.state.errors}
                error={this.state.validationMessage}
            >
                <p className="text-muted small mb-2">
                    Checked holidays pay at regular or OT rates. Unchecked holidays pay at the holiday rate (T15).
                </p>
                <div
                    className="overflow-auto border rounded shadow-sm"
                    style={{ flex: '1 1 0', minHeight: 0 }}
                >
                    <Table
                        size="sm"
                        bordered
                    >
                        <thead>
                            <tr>
                                <th style={{ width: '50px' }}>Excl.</th>
                                <th>Holiday</th>
                                <th>Date(s)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {holidays.map((h) => (
                                <tr key={h.id}>
                                    <td className="text-center align-middle">
                                        <FormGroup
                                            check
                                            className="mb-0 d-flex justify-content-center align-items-center pl-0"
                                        >
                                            <Input
                                                type="checkbox"
                                                id={`holiday-${h.id}`}
                                                className="position-static m-0"
                                                checked={!h.isPaid}
                                                onChange={() => this.toggleHoliday(h.id)}
                                            />
                                        </FormGroup>
                                    </td>
                                    <td className="align-middle">
                                        <Label
                                            for={`holiday-${h.id}`}
                                            className="mb-0 cursor-pointer"
                                        >
                                            {h.name}
                                        </Label>
                                    </td>
                                    <td className="text-muted small align-middle">
                                        {(h.dates ?? []).map((d) => new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })).join(' | ')}
                                    </td>
                                </tr>
                        ))}
                            {holidays.length === 0 && !this.state.loading && (
                            <tr>
                                <td
                                    colSpan={3}
                                    className="text-center text-muted"
                                >
                                    No system holidays defined.
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </Table>
                </div>
            </SlideForm>
        );
    }
}
